import { Dropdown } from 'antd';
import { useMemo } from 'react';

import { DeleteDocIcon, EditDocIcon } from '../../assets';
import FolderExportOutlined from '../../assets/common/FolderExportOutlined';
import FolderOpenOutlined from '../../assets/common/FolderOpenOutlined';
import FolderPlusOutlined from '../../assets/common/FolderPlusOutlined';
import HomeOutlined from '../../assets/common/HomeOutlined';
import AngleRightOutlined from '../../assets/docchat/AngleRightOutlined';
import ThreeDotOutlined from '../../assets/docchat/ThreeDotOutlined';
import { LOADING } from '../../Constants/commonConstants';
import { stopPropagationFunc } from '../../utils/functions';

const dateFunc = (data) => {
  return data?.upload_time
    ? new Date(data.upload_time)
        .toLocaleString('en-In', {
          dateStyle: 'long',
          timeZone: 'Asia/Kolkata',
        })
        ?.replace(',', '')
        ?.replace(' at', ',')
    : null;
};

const CollectionListItem = ({
  index,
  collectionData, // el
  data, // itm
  selectedDoc,
  uploadStatus,
  handleDocumentClick,
  handleModal,
  records,
  active,
}) => {
  const moveItems = useMemo(() => {
    return [
      {
        key: '1',
        label: 'Move to a new folder',
        icon: (
          <div className='flex'>
            <FolderPlusOutlined />
          </div>
        ),
        onClick: (e) => {
          stopPropagationFunc(e);
          handleModal('newFolder', data);
        },
      },
      {
        key: '2',
        label: 'Remove from folder',
        icon: (
          <div className='flex'>
            <HomeOutlined />
          </div>
        ),
        onClick: (e) => {
          stopPropagationFunc(e);
          handleModal('removeFromFolder', {
            collectionId: collectionData?.collection_id,
            ...data,
          });
        },
      },
      ...(records?.map((item) =>
        item?.collection_id && collectionData?.collection_id !== item?.collection_id
          ? {
              key: item?.chat_id ?? item?.collection_id,
              label: item?.collection_name,
              icon: (
                <div className='flex'>
                  <FolderOpenOutlined size={14} />
                </div>
              ),
              onClick: (e) => {
                stopPropagationFunc(e);
                handleModal('moveToFolder', {
                  ...data,
                  collectionId: item?.collection_id,
                });
              },
            }
          : null
      ) ?? []),
    ];
  }, [records]);

  const items = [
    {
      key: 'edit',
      label: 'Rename File',
      icon: <EditDocIcon />,
      onClick: (e) => {
        stopPropagationFunc(e);
        handleModal('edit', data);
      },
    },
    {
      key: 'move',
      label: (
        <div className='flex align-center' style={{ justifyContent: 'space-between' }}>
          <div className='flex align-center' style={{ gap: '8px' }}>
            <FolderExportOutlined />
            <span>Move</span>
          </div>
          <AngleRightOutlined />
        </div>
      ),
      children: moveItems,
      popupClassName: 'move-sub-menu-popup',
    },
    {
      key: 'delete',
      label: 'Delete file',
      icon: <DeleteDocIcon />,
      onClick: (e) => {
        stopPropagationFunc(e);
        handleModal('delete', data);
      },
    },
  ];

  return (
    <li
      className={`list-item ${active ? 'highlight' : ''}`}
      onClick={() => {
        handleDocumentClick({ ...collectionData, index, ...data });
      }}
    >
      <div className='info-container'>
        <div className='doc-name ellipsis'>{data?.document_name}</div>
        <span className='fs-10 color-n8'>{dateFunc(data)}</span>
      </div>
      {uploadStatus !== LOADING && (
        <div
          className={
            (selectedDoc?.document_id &&
              selectedDoc?.document_id === collectionData?.document_id) ||
            (selectedDoc?.collection_id &&
              selectedDoc?.collection_id === collectionData?.collection_id)
              ? 'actions-active'
              : 'actions'
          }
        >
          <Dropdown
            menu={{ items }}
            trigger={['click']}
            overlayClassName='file-menu-dropdown'
            destroyOnHidden
          >
            <button className='action-btn' onClick={(e) => e.stopPropagation()}>
              <ThreeDotOutlined />
            </button>
          </Dropdown>
        </div>
      )}
    </li>
  );
};

export default CollectionListItem;
